import Vue from 'vue'

const state = {
    is_offline: false
}

const actions = {
    SET_OFFLINE(context, [is_offline]) {
        context.commit('SAVE_OFFLINE', [is_offline])
    },
}

const mutations = {
    SAVE_OFFLINE: (state, [is_offline]) => {
        Vue.set(state, 'is_offline', is_offline)
    },
}

const getters = {
    is_offline: state => {
        return state.is_offline
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}